<style>
#SimpleDataAttributionsTable .container {
  padding: 0px;
  max-height: 30vh;
}
/* #SimpleDataAttributionsTable-scroll {

  } */

#SimpleDataAttributionsTable .container .v-datatable tr {
  /*padding-bottom: 0px;
    margin-bottom: 0px;
    line-height: 1;
    height: 40px;*/
  height: auto;
  min-height: 20px;
}
/* #SimpleDataAttributionsTable .container .v-datatable th {

  }  */
#SimpleDataAttributionsTable .container .v-datatable td {
  height: 10px;
}
/* .v-menu__content {
  z-index: 1000 !important;
} */
#app > div.v-dialog__content.v-dialog__content--active {
  z-index: 1 !important;
}
#SimpleDataAttributionsTable .v-text-field__slot label,
#SimpleDataAttributionsTable .v-text-field__slot input,
#SimpleDataAttributionsTable
  > div.v-card__title
  > div.v-input.v-text-field.v-text-field--placeholder {
  font-size: 12px;
}
#SimpleDataAttributionsTable .row--center {
  text-align: center;
}
#SimpleDataAttributionsTable div.v-input__slot div.v-select__slot label {
  font-size: 12px !important;
}
#SimpleDataAttributionsTable .v-icon {
  font-size: 18px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  padding-right: 8px;
}
#SimpleDataAttributionsTable .v-input {
  font-size: inherit !important;
}
#SimpleDataAttributionsTable td {
  line-height: 40px;
}
#SimpleDataAttributionsTable .container .layerSelect .v-table__overflow {
  width: fit-content;
  width: -moz-fit-content;
}
</style>

<template>
  <v-bottom-sheet
    v-model="show"
    hide-overlay
    persistent
    full-width
    class="simple-data-attr-table__container"
  >
    <ExportTableData
      ref="pobierz"
      type-source="attr-table"
      :filtred-items="elementsExport"
      :srid="srid"
      :projection="$root.projection"
      :fields="fields"
    ></ExportTableData>
    <TableDataMenu
      ref="selectMenu"
      :menu-items="menuItems"
      @selected="selectTypeMenuExecut"
    ></TableDataMenu>
    <v-card
      id="SimpleDataAttributionsTable"
      ref="card"
    >
      <resize-observer @notify="onResize"></resize-observer>
      <v-card-title>
        <!--height="10"-->
        <v-select
          placeholder="Zaznaczona warstwa"
          style="max-width: 300px;"
          :items="layersList"
          item-value="key"
          item-text="name"
          :return-object="true"
          no-data-text="Brak warstw"
          v-model="currentLayer"
          :disabled="disabledButtons"
        ></v-select>
        <VBtnGroup>
          <template>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  @click="filterActive = !filterActive"
                  :input-value="filterActive"
                >
                  <v-icon style="padding-left:8px">filter_list</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Filtrowanie po kolumnach</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="countFiltresSelected > 0"
                  color="error"
                  @click="clearFilters"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Wyczyść filtrowanie</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  @click="filterExtentActive = !filterExtentActive"
                  :input-value="filterExtentActive"
                >
                  <v-icon>fullscreen</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Filtrowanie po zasięgu</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="!!currentLayer"
                  @click="exportItems($event)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Pobierz</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="!!currentLayer && mode == 'analysis-water-cutting'"
                  @click="selectTypeMenu($event)"
                >
                  <v-icon>crop</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Zaznacz</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="!!currentLayer && mode == 'analysis-water-cutting'"
                  @click="showDialogSaveRecipients"
                >
                  <v-icon>fas fa-user-plus</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Zapisz odfiltrowaną grupę</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="!!currentLayer && mode == 'analysis-water-cutting'"
                  @click="showDialogLoadRecipients"
                >
                  <v-icon>fas fa-user-check</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Wczytaj odfiltrowaną grupę</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template slot="activator">
                <v-btn
                  flat
                  v-if="!!currentLayer && mode == 'analysis-water-cutting'"
                  @click="showDialogRaportRecipients"
                >
                  <v-icon>far fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span class="font--primary">Wygeneruj raport</span>
            </v-tooltip>
          </template>
        </VBtnGroup>
        <span class="font--primary">
          Liczba elementów:
          <span
            class="font--primary"
            v-text="filteredItemsLength"
          ></span>
        </span>
        <v-spacer />
        <v-text-field
          v-model="searchBefore"
          :disabled="disabledButtons"
          append-icon="search"
          label="Szukaj"
          single-line
          hide-details
          style="padding-top:0;margin-top:-8px;max-width:300px;"
        />
        <v-tooltip bottom>
          <template slot="activator">
            <v-btn
              @click="closePanel"
              color="red"
              dark
              icon
              flat
            >
              <v-icon dark>clear</v-icon>
            </v-btn>
          </template>
          <span class="font--primary">Zamknij panel</span>
        </v-tooltip>
      </v-card-title>
      <v-container
        id="SimpleDataAttributionsTable-scroll"
        class="scroll-y"
        fluid
      >
        <v-data-table
          ref="dataTable"
          item-key="__index"
          :headers="headers"
          :items="filtredItems"
          :pagination.sync="pagination"
          :custom-filter="externalFilterHandler"
          :search="search"
          :filter="customFilter"
          class="elevation-1"
          select-all
          hide-actions
          v-scroll:#SimpleDataAttributionsTable-scroll="onScroll"
          :class="{layerSelect : !!currentLayer}"
        >
          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-if="!currentLayer"
            >Wybierz warstwę aktywną</v-alert>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-else
            >Brak danych spełniających kryteria filtrowania</v-alert>
          </template>
          <template
            slot="headers"
            slot-scope="props"
          >
            <tr>
              <th>Akcje</th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                <span
                  class="font--primary"
                  v-text="header.text"
                />
              </th>
            </tr>
            <tr v-if="filterActive">
              <th />
              <th
                v-for="header in props.headers"
                :key="header.text"
              >
                <template v-if="header.value != '__index'">
                  <VInputFilter
                    v-model="daneFiltra[header.value]"
                    :type="header.type"
                    :combo="header.combo"
                    :combo-items="header.comboItems"
                  />
                </template>
                <template v-else>
                  <th />
                </template>
              </th>
            </tr>
          </template>
          <template
            slot="items"
            slot-scope="props"
          >
            <tr class="row--center">
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  class="mr-2"
                  @click="zoomTo(props.item)"
                  style="position:relative;top:3px;"
                >room</v-icon>
              </td>
              <td v-text="props.item.__index" />
              <td v-text="props.item.__db_id" />
              <td
                v-for="field in fields"
                :key="field.name"
              >
                <span
                  class="font--primary"
                  v-text="props.item[field.name] || ''"
                  style="white-space: nowrap;"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="pagination.page"
          v-if="pages > 1"
          :total-visible="pages < 10 ? pages : 10"
          :length="pages"
        ></v-pagination>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import {Vector as VectorLayer} from "ol/layer";
import {getForViewAndSize} from "ol/extent";
import {GeoJSON} from "ol/format";
import {Cluster} from "ol/source";

let formatGeoJSON;

import moment from "moment";
import {saveAs} from "file-saver";

import VBtnGroup from "../components/VBtnGroup";
import VInputFilter from "../components/VInputFilter";
import TableDataMenu from "../components/TableDataMenu";
import {ResizeObserver} from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import ExportTableData from "../../../shared/ExportTableData";

//templates
import templateModalDynamicBase from "../../../shared/templateModalDynamicBase.html";
import templateDialogSaveRecipients from "../template/templateDialogSaveRecipients.html";
import templateDialogLoadRecipients from "../template/templateDialogLoadRecipients.html";
import templateDialogRaportRecipients from "../template/templateDialogRaportRecipients.html";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import isArray from "lodash/isArray";
import each from "lodash/each";
import eq from "lodash/eq";
import lt from "lodash/lt";
import lte from "lodash/lte";
import gt from "lodash/gt";
import gte from "lodash/gte";
import startsWith from "lodash/startsWith";
import endsWith from "lodash/endsWith";
import template from "lodash/template";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
mixin(_, {
  map,
  filter,
  includes,
  isEmpty,
  some,
  isArray,
  each,
  chain,
  template,

  eq,
  eqSoft(value, other) {
    return value == other;
  },
  lt,
  lte,
  gt,
  gte,
  startsWith,
  endsWith,
  isNull,
  isUndefined,

  debounce,
  throttle
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    VBtnGroup,
    VInputFilter,
    ExportTableData,
    TableDataMenu,
    "resize-observer": ResizeObserver
  },
  data: () => ({
    show: false,
    currentLayer: undefined,
    mode: "simple",
    disabledButtons: false,

    offsetTop: 0,
    searchBefore: "",
    search: "",

    filterActive: false,
    filterExtentActive: false,

    pagination: {
      sortBy: "index",
      rowsPerPage: 100,
      page: 1
    },

    daneFiltra: {},
    filtersType: {},
    extent: [],

    headers: [],
    items: [],
    filtredItems: [],
    fields: [],

    selectedIds: {},
    selectEnable: false,
    updateWaterUsageRecipients: 0,

    ignore: false,
    filteredItemsLength: undefined
  }),
  computed: {
    map() {
      return this.$store.getters.getMap;
    },
    layers() {
      const self = this;
      if(!self.map) {
        return {};
      }
      const wodkan_layers = _.chain(
        self.map
          .getLayers()
          .item(2) //warstwy wodkan
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => ({
          name: layer.get("full_name"),
          short_name:
            layer.get("full_name").length > 24
              ? `${layer.get("full_name").slice(0, 24)}...`
              : layer.get("full_name"),
          key: layer.get("full_type"),
          save_key: layer.get("type"),
          get save_key_suffix() {
            return layer.get("full_type").split("@")[1];
          },
          type: "wodkan",
          fields: layer.get("fields"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const user_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(0) //warstwy użtkownika
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `WU: ${layer.get("name")}`,
          table: layer.get("table"),
          short_name:
            layer.get("name").length > 21
              ? `WU:  ${layer.get("name").slice(0, 21)}...`
              : `WU: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "user",
          fields: layer.get("fields"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const temp_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(1) //warstwy tymczasowe
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `T: ${layer.get("name")}`,
          short_name:
            layer.get("name").length > 22
              ? `T:  ${layer.get("name").slice(0, 22)}...`
              : `T: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "temp",
          fields: layer.get("fields"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      return _.keyBy([...wodkan_layers, ...user_layers, ...temp_layers], "key");
    },
    layersList() {
      if(this.filterLayers.length === 0) {
        return Object.values(this.layers);
      } else {
        return _.filter(this.layers, (layer, key) =>
          _.includes(this.filterLayers, key)
        );
      }
    },
    srid() {
      return this.$store.getters.getSrid;
    },

    mapCenter() {
      return this.$store.getters.getMapCenter;
    },
    tableDataActive() {
      return this.$store.getters.getTableDataActive;
    },
    currentBookmark() {
      return this.$store.getters.getCurrentBookmark;
    },

    elementsExport() {
      if(this.filtredItems.length !== 0) {
        return _.map(this.filtredItems, v => v.__instance);
      } else {
        return _.map(this.items, v => v.__instance);
      }
    },

    countFiltresSelected() {
      return _.filter(this.daneFiltra, (data, column) => {
        if(_.isEmpty(data)) {
          return false;
        }
        switch(
        _.startsWith(data.type, "not_") ? data.type.substr(4) : data.type
        ) {
          case "eq":
          case "contains":
          case "start_with":
          case "end_with": {
            if(!data.value) {
              return false;
            }
          }
        }
        return true;
      }).length;
    },
    pages() {
      if(
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    menuItems() {
      if(this.selectEnable) {
        return [
          {
            key: "disable-select",
            text: "Wyłącz zaznaczanie"
          },
          {
            key: "clear-select",
            text: "Wyczyść zaznaczone"
          }
        ];
      } else {
        return [
          {
            key: "single-select",
            text: "Zaznacz pojedynczy"
          },
          {
            key: "multi-select",
            text: "Zaznacz zasięgiem"
          },
          {
            key: "multi2-select",
            text: "Zaznacz wielokątem"
          },
          {
            key: "attr-select",
            text: "Zaznacz po atrybucie"
          },
          {
            key: "clear-select",
            text: "Wyczyść zaznaczone"
          }
        ];
      }
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    }
  },
  asyncComputed: {
    waterUsageRecipients: {
      get() {
        return fetch(
          `${this.$store.getters.getApiURL}/water-usage/recipients?token=${
          this.$store.getters.getToken
          }`
        )
          .then(r => r.json())
          .then(data => data)
          .catch(() => []);
      },
      default: () => [],
      watch: ["updateWaterUsageRecipients"]
      //lazy: true,
    }
  },
  watch: {
    filterActive(_new) {
      if(!_new) {
        this.daneFiltra = {};
        this.generateFilters();
      }
    },
    filterExtentActive(_new) {
      if(_new) {
        this.extent = this.calculateExtent();
      } else {
        this.extent = [];
      }
      this.updateFilter();
    },
    daneFiltra: {
      handler(_new, _old) {
        this._computedWatchers.countFiltresSelected.update();
        this.updateFilter();
      },
      deep: true
    },
    mapCenter() {
      if(this.filterExtentActive) {
        this.extent = this.calculateExtent();
        this.updateFilter();
      }
    },
    map() {
      this._computedWatchers.layers.update();
      this._computedWatchers.layersList.update();
    },

    searchBefore(_new) {
      this.changeSearchStart(_new);
      this.changeSearchEnd(_new);
    },
    tableDataActive(_new) {
      if(this.ignore) {
        this.ignore = false;
        return;
      }
      if(_new) {
        this.openAttributeTableData();
      } else {
        this.closeAttributeTableData();
      }
    },
    currentBookmark(_new) {
      if(_new === "edition") {
        this.$store.commit("setTableDataActive", false);
      }
    },
    currentLayer(_new) {
      this.refreshAttributeTableData(_new.instance);
      if(_new.instance.getVisible()) {
        this.refreshAttributeTableData(_new.instance);
      } else {
        this.$root.$once('toggleLayerEnd', (key, value) => {
          if(key === _new.key) {
            setTimeout(() => {
              this.refreshAttributeTableData(_new.instance);
            }, 1000);
          }
        });
        this.$root.$emit("toggleLayer", this.currentLayer.key, true);
      }
    }
  },
  created() {
    this.layer = false;
    this.filterLayers = [];
    this.tables = {};

    formatGeoJSON = new GeoJSON({
      dataProjection: this.srid,
      featureProjection: this.$root.projection
    });

    this.$root.$on(
      "attributionDataIncludesID",
      (tables, table, mode = "simple") => {
        this.filterLayers = Object.keys(tables);
        this._computedWatchers.layers.update();
        this._computedWatchers.layersList.update();
        this.tables = tables;
        this.currentLayer = this.layers[table];
        this.clearFilters();
        this.filterActive = true;
        this.mode = mode || "simple";

        if(mode === "analysis-water-cutting") {
          this.updateWaterUsageRecipients++;
        }

        this.openAttributeTableData();
        if(!this.tableDataActive) {
          this.ignore = true;
          this.$store.commit("setTableDataActive", true);
        }
      }
    );

    this.$root.$on("addedAttribute", () => setTimeout(this.refreshAttribute, 5000));
    this.$root.$on("removedAttribute", () => setTimeout(this.refreshAttribute, 5000));

    moment.locale("pl");
  },
  mounted() {
    this.$root.$on("selectionElementCallback", this.selectionElementCallback);
  },
  updated() {
    this.filteredItemsLength = this.pagination.totalItems
  },
  beforeDestroy() {
    this.$root.$off("selectionElementCallback", this.selectionElementCallback);
  },
  methods: {
    refreshAttributeTableData(layer) {
      this.$root.$emit(
        "showSnackbar",
        "blue",
        "Ładowanie danych proszę czekać"
      );
      setTimeout(() => {
        this.fields = layer.get("fields");
        this.layer = layer;
        this.layerNotLoaded = !layer.getVisible();
        this.headers = this.generateHeaders();
        this.items = this.generateItems();
        this.generateFilters();
        this.updateFilter();

        if(
          this.filterLayers.length !== 0 &&
          this.tables[this.currentLayer.key].length !== 0
        ) {
          this.daneFiltra["__db_id"].value = this.tables[this.currentLayer.key];
          this.daneFiltra["__db_id"].type = "includes";

          this._computedWatchers.countFiltresSelected.update();
          this.updateFilter();
          this.$forceUpdate();
        }
        this.show = true;
      }, 500);
    },
    openAttributeTableData() {
      this._computedWatchers.layers.update();
      this._computedWatchers.layersList.update();
      if(this.currentLayer) {
        this.refreshAttributeTableData(this.currentLayer.instance);
      }
      this.show = true;
    },
    closeAttributeTableData() {
      this.layer = false;
      this.filterActive = false;
      this.fields = [];
      this.headers = [];
      this.items = [];
      this.daneFiltra = {};
      this.filtersType = {};
      this.filterLayers = [];
      this.tables = [];
      this.search = '';
      this.searchBefore = '';

      this.selectedIds = {};
      this.mode = "simple";
      this.selectEnable = false;
      this.filtredItems = [];
      this.pagination.totalItems = this.filtredItems.length;
      this._computedWatchers.pages.update();
      this.offsetTop = 0;
      this.show = false;
    },

    generateHeaders() {
      const headers = [];
      headers.push({
        text: "#",
        align: "left",
        value: "__index",
        type: "integer",
        combo: false,
        comboItems: []
      });
      headers.push({
        text: "ID",
        align: "left",
        value: "__db_id",
        type: "integer",
        combo: false,
        comboItems: []
      });
      _.each(this.fields, field => {
        if("dictionary" in field) {
          headers.push({
            text: field.display_name,
            align: "left",
            value: field.name,
            type: field.data_type,
            combo: true,
            comboItems: _.map(field.dictionary, v => v.value)
          });
        } else {
          headers.push({
            text: field.display_name,
            align: "left",
            value: field.name,
            type: field.data_type,
            combo: false,
            comboItems: []
          });
        }
      });

      return headers;
    },
    generateItems() {
      const items = [];
      let source = this.layer.getSource();
      if(source instanceof Cluster) {
        source = source.getSource();
      }
      _.each(source.getFeatures(), (feature, index) => {
        const item = {
          __index: index,
          __db_id: feature.getId(),
          __instance: this.$root.createProxy(feature)
        };
        _.each(this.fields, field => {
          if("dictionary" in field) {
            const dictionary = field.dictionary[feature.get(field.name)] || {};
            item[field.name] = dictionary.value || null;
          } else {
            item[field.name] = feature.get(field.name) || null;
          }
        });
        items.push(item);
      });
      return items;
    },
    generateFilters() {
      this.daneFiltra = {};
      this.filtersType = {};
      _.each(this.headers, header => {
        this.$set(this.daneFiltra, header.value, {});
        this.filtersType[header.value] = header.type;
      });
    },

    calculateExtent() {
      const size = [100, 100];
      const view = this.map.getView();
      const element = this.map
        .getTargetElement()
        .getElementsByClassName("ol-viewport")[0];
      if(element) {
        const metrics = getComputedStyle(element);
        size[0] = parseInt(metrics.width, 10);
        size[1] = parseInt(metrics.height, 10);
      }
      size[1] -= this.$refs.card.$el.offsetHeight;

      //this.map.getView().calculateExtent(size);
      return getForViewAndSize(
        this.map.getCoordinateFromPixel([size[0] / 2, size[1] / 2]),
        view.getResolution(),
        view.getRotation(),
        size
      );
    },

    updateFilter() {
      //this._computedWatchers.filtredItems.update();
      this.filtredItems = this.filterItems();
      this.pagination.totalItems = this.filtredItems.length;
      this._computedWatchers.pages.update();
    },
    convertData(type, value) {
      if(_.isArray(value)) {
        return _.map(value, v => this.convertData(type, v));
      }
      if(_.isUndefined(value) || _.isNull(value)) {
        return value;
      } else if(type === "datetime" || type === "date") {
        //date
        return moment.utc(value || "").toDate();
      } else if(type === "time") {
        //date
        return moment(value || "", "HH:mm").toDate();
      } else if(type === "integer" || type === "real") {
        //number
        return +value;
      } else {
        return `${value}`;
      }
    },
    filterItems() {
      let items = this.items.slice();

      if(this.filterExtentActive) {
        const ids = _.map(
          this.layer.getSource().getFeaturesInExtent(this.extent),
          f => f.getId()
        );
        items = _.filter(items, item => _.includes(ids, item.__db_id));
      }

      if(this.filterActive) {
        _.each(this.daneFiltra, (data, column) => {
          if(!_.isEmpty(data)) {
            const value = this.convertData(
              this.filtersType[column],
              data.value
            );

            items = _.filter(items, item =>
              this.filterExecut(
                this.convertData(this.filtersType[column], item[column]),
                data.type,
                value
              )
            );
          }
        });
      }

      return items;
    },
    filterExecut(item, type, value) {
      let negation = false;
      if(_.startsWith(type, "not_")) {
        negation = true;
        type = type.substr(4);
      }
      value = typeof value === "string" ? value.toLowerCase() : value
      item = typeof item === "string" ? item.toLowerCase() : item

      let result = true;
      switch(type) {
        case "eq":
          result = !value || _.eqSoft(item, value);
          break;
        case "empty":
          result = _.isEmpty(item);
          break;
        case "null":
          result = _.isUndefined(item) || _.isNull(item);
          break;
        case "contains":
          result = !value || _.includes(item, value);
          break;
        case "includes":
          result = !value || _.includes(value, item);
          break;
        case "start_with":
          result = !value || _.startsWith(item, value);
          break;
        case "end_with":
          result = !value || _.endsWith(item, value);
          break;
        case "lt":
          result = _.lt(item, value);
          break;
        case "lte":
          result = _.lte(item, value);
          break;
        case "gt":
          result = _.gt(item, value);
          break;
        case "gte":
          result = _.gte(item, value);
          break;
      }
      return negation ? !result : result;
    },

    changeSort(column) {
      if(this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    changeSearchStart: _.throttle(function (_new) {
      this.$root.$emit(
        "showSnackbar",
        "blue",
        "Wyszukiwanie danych"
      );
    }, 1000),
    changeSearchEnd: _.debounce(function (_new) {
      this.search = _new;
    }, 1000),

    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    onResize: _.debounce(function (e) {
      if(this.filterExtentActive) {
        this.extent = this.calculateExtent();
        this.updateFilter();
      }
    }, 5000),
    closePanel() {
      this.$store.commit("setTableDataActive", false);
    },

    zoomTo(item) {
      this.$root.$emit("zoomToGeometry", item.__instance.getGeometry(), {
        padding: [0, 0, this.$refs.card.$el.offsetHeight, 0],
        select: true
      });
    },
    clearFilters() {
      if(this.mode === "analysis-water-cutting") {
        this.$root.$emit("clearSelectionFeatures");

        this.tables.partitions = [];
        this.tables.watermeters = [];
        this.selectedIds.partitions = [];
      }

      this.generateFilters();
    },

    exportItems(event) {
      this._computedWatchers.elementsExport.update();
      if("pobierz" in this.$refs) {
        this.$refs.pobierz.showExportMenu(event);
      }
    },

    selectTypeMenu(event) {
      if("selectMenu" in this.$refs) {
        this.$refs.selectMenu.showMenu(event);
      }
    },
    selectTypeMenuExecut(type) {
      switch(type) {
        case "single-select": {
          this.selectNewObject("single");
          break;
        }
        case "multi-select": {
          this.selectNewObject("extent");
          break;
        }
        case "multi2-select": {
          this.selectNewObject("Polygon");
          break;
        }
        case "disable-select": {
          this.$root.$emit("disableSelectionElement");
          this.selectEnable = false;
          this._computedWatchers.menuItems.update();
          this.$forceUpdate();
          this.map.getViewport().style.cursor = "";
          break;
        }
        case "attr-select": {
          //TODO: dorobić
          break;
        }
        case "clear-select": {
          this.clearFilters();
          break;
        }
        default:
          return;
      }
    },
    selectNewObject(type) {
      const self = this;
      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";
      if(!("partitions" in this.selectedIds)) {
        this.selectedIds.partitions = [];
      }

      self.selectEnable = true;
      this._computedWatchers.menuItems.update();
      self.$root.$emit("enableSelectionElement", {
        layers: ["partitions"], //punkty rozbioru wody
        extent: type === "extent", //zanzaczanie zasięgiem lub pojedyńczo
        geometry: type === "Polygon", //zanzaczanie geometrią
        geometryType: type,
        multi: true, //nie czyści poprzednio zaznaczonych
        once: false // działa puki się nie wyłaczy
      });
    },
    selectionElementCallback(featuresLayers) {
      const self = this;
      if(!self.selectEnable) return;
      if(!self.filterActive) {
        self.filterActive = true;
      }

      const featuresLayer = featuresLayers.partitions;
      if(featuresLayer) {
        const ids = _(featuresLayer.features)
          .map(feature => feature.getId())
          .filter(
            featureId =>
              !_.some(this.selectedIds.partitions, id => id === featureId)
          )
          .value();
        if(!_.isEmpty(ids)) {
          self.partitionsToWatermeters([...this.tables.partitions, ...ids]);
        }
      }
    },
    partitionsToWatermeters(partitionsIds) {
      const watermetersLayer = this.layers["watermeters"].instance.__value;
      const watermetersIds = _(watermetersLayer.getSource().getSource().getFeatures())
        .filter(f => _.includes(partitionsIds, f.get("parent_partition")))
        .map(f => f.getId())
        .value();

      this.tables.partitions = partitionsIds;
      this.tables.watermeters = watermetersIds;

      if(this.currentLayer.key === "partitions") {
        this.daneFiltra["__db_id"].value = partitionsIds;
      } else if(this.currentLayer.key === "watermeters") {
        this.daneFiltra["__db_id"].value = watermetersIds;
      }

      this.daneFiltra["__db_id"].type = "includes";

      this._computedWatchers.countFiltresSelected.update();
      this.updateFilter();
      this.$forceUpdate();
    },
    showDialogSaveRecipients() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateDialogSaveRecipients
      });
      self.waterUsageRecipient = "";

      const execut = name => {
        name = name.trim();
        if(name === "") {
          self.$root.$emit("showSnackbar", "red", "Nie wybrano żadnej grupy");
          return;
        }

        let partitions = [];
        if(self.currentLayer.key === "partitions") {
          partitions = _.map(self.filtredItems, v => v.__instance.getId());
        } else if(self.currentLayer.key === "watermeters") {
          partitions = self.tables.partitions;
        }

        fetch(
          `${self.$store.getters.getApiURL}/water-usage/recipients?token=${
          self.$store.getters.getToken
          }`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              name,
              partitions
            })
          }
        )
          .then(response => {
            if(response.status === 200) {
              return [response.status, response.json()];
            } else if(Math.floor(response.status) === 4) {
              return [response.status, response.json()];
            } else {
              return [response.status, response.text()];
            }
          })
          .then(([status, data]) => {
            if(status === 200) {
              self.$root.$emit("showSnackbar", "success", "Dodano grupę");
              self.updateWaterUsageRecipients++;
            } else if(Math.floor(status) === 4) {
              self.$root.$emit("showSnackbar", "red", data.message);
            } else {
              self.$root.$emit("showSnackbar", "red", data);
            }
          });
      };

      self.disabledButtons = true;
      self.$modal.show(
        {
          template,
          props: ["title", "buttons"],
          data: () => ({
            waterUsageRecipient: self.waterUsageRecipient
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Zapisz grupę odbiorców",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Zapisywanie proszę czekać"
                );
                setTimeout(() => execut(self.waterUsageRecipient), 500);
              }
            }
          ]
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {
            self.disabledButtons = false;
          }
        }
      );
    },
    showDialogLoadRecipients() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateDialogLoadRecipients
      });
      self.waterUsageRecipient = false;

      const execut = grupa => {
        if(!grupa) {
          self.$root.$emit("showSnackbar", "red", "Nie wybrano żadnej grupy");
          return;
        }

        const currentLayer = this.layers["partitions"].instance.__value;
        if(!currentLayer) {
          return;
        }

        const features = _.filter(currentLayer.getSource().getFeatures(), f =>
          _.includes(grupa.partitions, f.getId())
        );
        if(!features || features.length === 0) {
          return;
        }

        self.selectedLayer.getSource().clear(true);
        self.$store.commit(
          "setCurrentSelectedFeatures",
          _.map(features, feature => self.$root.createProxy(feature))
        );
        self.selectedLayer.getSource().addFeatures(features);

        self.partitionsToWatermeters(grupa.partitions.slice());
      };

      self.disabledButtons = true;
      self.$modal.show(
        {
          template,
          props: ["title", "buttons", "waterUsageRecipients"],
          data: () => ({
            waterUsageRecipient: false
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Zapisz grupę odbiorców",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Zapisywanie proszę czekać"
                );
                setTimeout(() => execut(self.waterUsageRecipient), 500);
              }
            }
          ],
          waterUsageRecipients: self.waterUsageRecipients
        },
        {
          height: "auto",
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {
            self.disabledButtons = false;
          }
        }
      );
    },
    customFilter(item, search) {
      if(!search) return item
      search = search.toString().toLowerCase()
      if(search.trim() === '') return item

      return Object.keys(item).some(j => {
        const val = item[j]
        return val != null &&
          typeof val !== 'boolean' &&
          val.toString().toLowerCase().indexOf(search) !== -1
      })
    },
    externalFilterHandler(items, search, filter, headers) {
      return items.filter(item => {
        return filter(item, search)
      })
    },
    showDialogRaportRecipients() {
      const self = this;

      let nameModal;
      const template = _.template(templateModalDynamicBase, {
        interpolate: /%%([\s\S]+?)%%/g
      })({
        content: templateDialogRaportRecipients
      });
      self.waterUsageStart = "2016-01";
      self.waterUsageEnd = new Date().toISOString().slice(0, 7);

      function prepareDate(s) {
        return s.replace(new RegExp("([0-9]{4})-([0-9]{2})", "g"), "01-$2-$1");
      }

      const execut = (start, end) => {
        if(!start || !end) {
          self.$root.$emit("showSnackbar", "red", "Błędne daty");
          return;
        }

        const attrName = this.currentLayer.key === 'watermeters' ? 'watermeters' : 'partitions'

        const payload = {
          date_from: prepareDate(start),
          date_to: prepareDate(end)
        };
        if(this.$refs.dataTable.searchLength != this.items.length) {
          payload[attrName] = []
          let pages = Math.ceil(this.$refs.dataTable.searchLength / 100)
          for(let i = 1; i <= pages; i++) {
            this.pagination.page = i
            this.$refs.dataTable.filteredItems.forEach(item => {
              payload[attrName].push(item.__db_id)
            })
          }
          this.pagination.page = 1
        }
        fetch(
          `${self.$store.getters.getApiURL}/water-usage/report?token=${
          self.$store.getters.getToken
          }`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.ms-excel"
            },
            responseType: "blob",
            body: JSON.stringify(payload)
          }
        )
          .then(response =>
            response.status === 200
              ? response.blob()
              : Promise.reject(response.text())
          )
          .then(blob => {
            self.$root.$emit("showSnackbar", "success", "Wygenerowano raport");
            saveAs(blob, `Raport ze zużycia wody: ${start}-${end}.xlsx`);
          })
          .catch(text => {
            self.$root.$emit("showSnackbar", "red", text);
          });
      };

      self.disabledButtons = true;
      self.$modal.show(
        {
          template,
          props: ["title", "buttons"],
          data: () => ({
            waterUsageStart: self.waterUsageStart,
            waterUsageEnd: self.waterUsageEnd,

            startData: self.waterUsageStart,
            endData: self.waterUsageEnd
          }),
          methods: {
            updateValue(name, value) {
              if(name in self) {
                self[name] = value;
              }
            }
          }
        },
        {
          title: "Wygeneruj raport",
          buttons: [
            {
              title: "ANULUJ",
              handler(event) {
                self.$modal.hide(nameModal);
              }
            },
            {
              title: "WYKONAJ",
              handler(event) {
                self.$modal.hide(nameModal);
                self.$root.$emit(
                  "showSnackbar",
                  "#2a579a",
                  "Generowanie prosze czekać"
                );
                setTimeout(
                  () => execut(self.waterUsageStart, self.waterUsageEnd),
                  500
                );
              }
            }
          ]
        },
        {
          height: "auto",
          width: 680,
          "click-to-close": false,
          classes: ["v--modal", "vue-dialog"]
        },
        {
          "before-open"(event) {
            nameModal = event.name;
          },
          "before-close"(event) {
            self.disabledButtons = false;
          }
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/panels/SimpleDataAttributionsTable.vue